import { ETrackerPages } from './pages';
import type { TTrackerPages } from './pages';

export const ETrackerChapters = {
  MARKET: 'market',
  CART: 'cart',
  CHECKOUT: 'checkout',
} as const;

export type TTrackerChapters = (typeof ETrackerChapters)[keyof typeof ETrackerChapters];

export const pageToTrackerChapters = (page: TTrackerPages) => {
  switch (page) {
    case ETrackerPages.CART:
      return ETrackerChapters.CART;
    case ETrackerPages.CHECKOUT:
      return ETrackerChapters.CHECKOUT;
    default:
      return ETrackerChapters.MARKET;
  }
};
